document.addEventListener("DOMContentLoaded", () => {
  const isDesktop = () => window.matchMedia("(min-width: 1100px)").matches;

  const headerWrapper = document.querySelector(".as-header-wrapper");
  const drawer = document.querySelector(".as-mob-drawer");

  let closeTimeout;
  let activeSubmenuItem = null;
  let isInsideMega = false;

  function getHeaderHeight() {
    return Math.ceil(headerWrapper?.getBoundingClientRect().height || 0);
  }

  function syncHeaderOffset() {
    if (!headerWrapper) return;

    document.documentElement.style.setProperty(
      "--header-height",
      `${getHeaderHeight()}px`,
    );
  }

  syncHeaderOffset();
  window.addEventListener("load", syncHeaderOffset);
  window.addEventListener("resize", syncHeaderOffset);

  function activateFirstSubmenuItem(detailsEl) {
    const firstItem = detailsEl.querySelector(".as-header__submenu-item");
    if (!firstItem) return;

    const handle = firstItem.dataset.handle;

    firstItem.classList.add("is-active");
    activeSubmenuItem = firstItem;

    detailsEl
      .querySelectorAll(".submenu-products-wrap")
      .forEach((productBlock) => {
        productBlock.hidden = true;
      });

    const target = detailsEl.querySelector(
      `.submenu-products-wrap[data-handle="${handle}"]`,
    );

    if (target) target.hidden = false;
  }

  function closeAllMega(exceptEl) {
    document.querySelectorAll(".as-header__details").forEach((el) => {
      if (el !== exceptEl) {
        el.setAttribute("aria-expanded", "false");
      }
    });
  }

  document.querySelectorAll(".as-header__submenu").forEach((submenu) => {
    submenu.addEventListener("mouseenter", () => {
      isInsideMega = true;
      clearTimeout(closeTimeout);
    });

    submenu.addEventListener("mouseleave", () => {
      isInsideMega = false;

      closeTimeout = setTimeout(() => {
        if (!isInsideMega && activeSubmenuItem) {
          activeSubmenuItem.classList.remove("is-active");
          activeSubmenuItem = null;
        }
      }, 120);
    });
  });

  document.querySelectorAll(".as-header__details").forEach((details) => {
    details.addEventListener("mouseenter", () => {
      if (!isDesktop()) return;

      clearTimeout(closeTimeout);

      closeAllMega(details);
      details.setAttribute("aria-expanded", "true");
      headerWrapper?.classList.add("is-mega-open");

      activateFirstSubmenuItem(details);
    });

    details.addEventListener("mouseleave", () => {
      if (!isDesktop()) return;

      closeTimeout = setTimeout(() => {
        details.setAttribute("aria-expanded", "false");

        const anyOpen = document.querySelector(
          '.as-header__details[aria-expanded="true"]',
        );

        if (!anyOpen) {
          headerWrapper?.classList.remove("is-mega-open");
        }
      }, 120);
    });
  });

  document.querySelectorAll(".as-header__submenu-item").forEach((item) => {
    item.addEventListener("mouseenter", () => {
      const details = item.closest(".as-header__details");
      const handle = item.dataset.handle;

      if (activeSubmenuItem && activeSubmenuItem !== item) {
        activeSubmenuItem.classList.remove("is-active");
      }

      item.classList.add("is-active");
      activeSubmenuItem = item;

      if (!details) return;

      details
        .querySelectorAll(".submenu-products-wrap")
        .forEach((productBlock) => {
          productBlock.hidden = true;
        });

      const target = details.querySelector(
        `.submenu-products-wrap[data-handle="${handle}"]`,
      );

      if (target) target.hidden = false;
    });
  });

  if (drawer) {
    const backBtn = drawer.querySelector(".as-mob-back");
    const backArea = drawer.querySelector(".as-mob-head-pill");
    const titleEl = drawer.querySelector(".as-mob-head-title");
    const headEl = drawer.querySelector(".as-mob-head");

    const stack = [{ level: 1, menuId: null, title: "Menu" }];

    function renderMobileMenu() {
      const state = stack[stack.length - 1];

      drawer.setAttribute("data-current-menu-level", state.level);
      drawer.setAttribute("data-current-menu-title", state.title || "Menu");

      if (headEl) {
        headEl.style.display = state.level === 1 ? "none" : "flex";
      }

      if (titleEl) {
        titleEl.textContent =
          state.level === 1 ? "MENU" : (state.title || "").toUpperCase();
      }

      if (backBtn) {
        backBtn.hidden = stack.length <= 1;
      }

      drawer.querySelectorAll(".as-mob-panel").forEach((panel) => {
        panel.hidden = true;
      });

      if (state.menuId) {
        const panel = drawer.querySelector(
          `.as-mob-panel[data-menu-id="${state.menuId}"]`,
        );

        if (panel) {
          panel.hidden = false;
        }
      }
    }

    function resetMobileMenu() {
      stack.length = 1;

      drawer.removeAttribute("data-active-tab");

      drawer.querySelectorAll(".as-mob-tab").forEach((button) => {
        button.classList.remove("is-active");
      });

      drawer.querySelectorAll(".as-mob-tab-panel").forEach((panel) => {
        panel.classList.add("is-active");
      });

      drawer.querySelectorAll(".as-mob-level").forEach((level) => {
        level.style.display = "";
      });

      renderMobileMenu();
    }
    function goBack() {
      if (stack.length <= 1) return;

      stack.pop();
      renderMobileMenu();
    }

    document.querySelectorAll(".as-mob-header__burger").forEach((burger) => {
      burger.addEventListener("click", () => {
        if (!headerWrapper) return;

        const isOpen = headerWrapper.classList.contains(
          "as-header-wrapper--open",
        );

        headerWrapper.classList.toggle("as-header-wrapper--open");
        document.body.classList.toggle("as-fixed", !isOpen);

        if (!isOpen) {
          resetMobileMenu();
        }
      });
    });

    drawer.addEventListener("click", (event) => {
      const nextLevelBtn = event.target.closest("[data-next-level]");
      if (!nextLevelBtn) return;

      drawer.querySelectorAll("[data-next-level]").forEach((item) => {
        item.classList.remove("is-active");
      });

      nextLevelBtn.classList.add("is-active");

      stack.push({
        level: Number(nextLevelBtn.dataset.nextLevel),
        menuId: nextLevelBtn.dataset.menuId,
        title: nextLevelBtn.dataset.title || "",
      });

      renderMobileMenu();
    });

    if (backArea) {
      backArea.addEventListener("click", goBack);
    }

    if (backBtn) {
      backBtn.addEventListener("click", (event) => {
        event.stopPropagation();
        goBack();
      });
    }

    resetMobileMenu();
  } else {
    document.querySelectorAll(".as-mob-header__burger").forEach((burger) => {
      burger.addEventListener("click", () => {
        if (!headerWrapper) return;

        const isOpen = headerWrapper.classList.contains(
          "as-header-wrapper--open",
        );

        headerWrapper.classList.toggle("as-header-wrapper--open");
        document.body.classList.toggle("as-fixed", !isOpen);
      });
    });
  }

  let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
  let ticking = false;

  function updateHeaderOnScroll() {
    if (!headerWrapper) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (headerWrapper.classList.contains("is-mega-open")) {
      headerWrapper.classList.remove("is-hidden");
      headerWrapper.classList.add("is-visible");
      lastScrollTop = scrollTop;
      ticking = false;
      return;
    }

    if (scrollTop < 80) {
      headerWrapper.classList.remove("is-hidden");
      headerWrapper.classList.add("is-visible", "static");
    } else if (scrollTop > lastScrollTop) {
      headerWrapper.classList.add("is-hidden");
      headerWrapper.classList.remove("is-visible", "static");
    } else {
      headerWrapper.classList.remove("is-hidden");
      headerWrapper.classList.add("is-visible");
      headerWrapper.classList.remove("static");
    }

    lastScrollTop = Math.max(scrollTop, 0);
    ticking = false;
  }

  window.addEventListener(
    "scroll",
    () => {
      if (!ticking) {
        window.requestAnimationFrame(updateHeaderOnScroll);
        ticking = true;
      }
    },
    { passive: true },
  );

  updateHeaderOnScroll();
});

function initMobileBannerSlider(scope = document) {
  const slider = scope.querySelector("[data-banner-slider]");
  if (!slider) return;

  const track = slider.querySelector("[data-banner-track]");
  const dotsWrap = slider.querySelector("[data-banner-dots]");

  if (!track || !dotsWrap) return;

  const slides = [...track.querySelectorAll(".as-mob-banner--small")];

  if (slides.length <= 1) return;

  dotsWrap.innerHTML = slides.map(() => "<span></span>").join("");

  const dots = [...dotsWrap.children];

  const setActive = (index) => {
    dots.forEach((dot) => dot.classList.remove("is-active"));
    dots[index]?.classList.add("is-active");
  };

  setActive(0);

  let raf = null;

  track.addEventListener(
    "scroll",
    () => {
      if (raf) cancelAnimationFrame(raf);

      raf = requestAnimationFrame(() => {
        let best = 0;
        let dist = Infinity;

        slides.forEach((slide, index) => {
          const currentDist = Math.abs(slide.offsetLeft - track.scrollLeft);

          if (currentDist < dist) {
            dist = currentDist;
            best = index;
          }
        });

        setActive(best);
      });
    },
    { passive: true },
  );

  dots.forEach((dot, index) => {
    dot.addEventListener("click", () => {
      track.scrollTo({
        left: slides[index].offsetLeft,
        behavior: "smooth",
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initMobileBannerSlider();
});

document.addEventListener("click", (event) => {
  const button = event.target.closest("[data-show-all-products]");

  if (!button) return;

  const productsContainer = button.previousElementSibling;

  productsContainer
    .querySelectorAll(".as-header-product-item.is-hidden")
    .forEach((item) => {
      item.classList.remove("is-hidden");
    });

  button.remove();
});

document.addEventListener("DOMContentLoaded", () => {
  const popup = document.querySelector("[data-search-popup]");
  if (!popup) return;

  const input = popup.querySelector(".as-search-popup__input");
  const liveResults = popup.querySelector("[data-search-live-results]");
  const productsGrid = popup.querySelector("[data-search-products-grid]");
  const prevBtn = popup.querySelector("[data-search-products-prev]");
  const nextBtn = popup.querySelector("[data-search-products-next]");

  const updateButtons = () => {
    if (!productsGrid || !prevBtn || !nextBtn) return;

    const hasOverflow = productsGrid.scrollWidth > productsGrid.clientWidth + 5;

    if (!hasOverflow) {
      prevBtn.hidden = true;
      nextBtn.hidden = true;
      return;
    }

    prevBtn.hidden = productsGrid.scrollLeft <= 5;
    nextBtn.hidden =
      productsGrid.scrollLeft >=
      productsGrid.scrollWidth - productsGrid.clientWidth - 5;
  };

  const openSearch = () => {
    popup.hidden = false;
    document.body.classList.add("as-search-open");

    setTimeout(() => {
      input?.focus();
      updateButtons();
    }, 150);
  };

  const closeSearch = () => {
    popup.hidden = true;
    document.body.classList.remove("as-search-open");

    if (liveResults) {
      liveResults.hidden = true;
      liveResults.innerHTML = "";
    }

    if (input) input.value = "";
  };

  document.addEventListener("click", (event) => {
    const openBtn = event.target.closest("[data-open-search-popup]");
    const closeBtn = event.target.closest("[data-close-search]");

    if (openBtn) {
      event.preventDefault();
      openSearch();
      return;
    }

    if (closeBtn) {
      event.preventDefault();
      closeSearch();
      return;
    }

    if (
      !popup.hidden &&
      !popup.contains(event.target) &&
      !event.target.closest("[data-open-search-popup]")
    ) {
      closeSearch();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !popup.hidden) {
      closeSearch();
    }
  });

  window.addEventListener("resize", updateButtons);

  productsGrid?.querySelectorAll("img").forEach((img) => {
    if (img.complete) return;
    img.addEventListener("load", updateButtons, { once: true });
  });

  prevBtn?.addEventListener("click", () => {
    productsGrid?.scrollBy({
      left: -278,
      behavior: "smooth",
    });
  });

  nextBtn?.addEventListener("click", () => {
    productsGrid?.scrollBy({
      left: 278,
      behavior: "smooth",
    });
  });

  productsGrid?.addEventListener("scroll", updateButtons);

  let timeout = null;

  input?.addEventListener("input", () => {
    const query = input.value.trim();

    clearTimeout(timeout);

    if (!query) {
      if (liveResults) {
        liveResults.hidden = true;
        liveResults.innerHTML = "";
      }
      return;
    }

    timeout = setTimeout(async () => {
      try {
        const response = await fetch(
          `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8`,
        );

        const data = await response.json();
        const products = data.resources?.results?.products || [];

        if (!liveResults) return;

        liveResults.hidden = false;

        if (!products.length) {
          liveResults.innerHTML = `<div class="as-search-no-results">No products found</div>`;
          return;
        }

        liveResults.innerHTML = `
          <div class="as-search-live-list">
            ${products
              .map((product) => {
                const image =
                  product.featured_image?.url || product.image || "";
                const price = product.price || "";
                const url = product.url || "#";

                return `
                  <a href="${url}" class="as-search-live-product">
                    ${
                      image
                        ? `<img class="as-search-live-product__image" src="${
                            image.includes("?")
                              ? image + "&width=160"
                              : image + "?width=160"
                          }" alt="${product.title}" loading="lazy">`
                        : ""
                    }
                    <div class="as-search-live-product__content">
                      <div class="as-search-live-product__title">${product.title}</div>
                      ${
                        price
                          ? `<div class="as-search-live-product__price">${price}</div>`
                          : ""
                      }
                    </div>
                  </a>
                `;
              })
              .join("")}
          </div>
        `;
      } catch (error) {
        console.error("Search error:", error);
      }
    }, 250);
  });

  let isDown = false;
  let startX = 0;
  let scrollLeft = 0;
  let dragged = false;

  productsGrid?.addEventListener("mousedown", (e) => {
    isDown = true;
    dragged = false;
    productsGrid.classList.add("is-dragging");

    startX = e.pageX;
    scrollLeft = productsGrid.scrollLeft;
  });

  productsGrid?.addEventListener("mousemove", (e) => {
    if (!isDown) return;

    const walk = e.pageX - startX;

    if (Math.abs(walk) > 5) dragged = true;

    productsGrid.scrollLeft = scrollLeft - walk;
  });

  ["mouseup", "mouseleave"].forEach((eventName) => {
    productsGrid?.addEventListener(eventName, () => {
      isDown = false;
      productsGrid.classList.remove("is-dragging");
    });
  });

  productsGrid?.addEventListener("click", (e) => {
    if (dragged) {
      e.preventDefault();
      e.stopPropagation();
    }
  });
});
document.addEventListener("click", (event) => {
  const item = event.target.closest("[data-ps-item]");

  if (!item) return;

  const input = document.querySelector(".as-search-popup__input");

  if (!input) return;

  input.value = item.dataset.psQuery;

  input.dispatchEvent(
    new Event("input", {
      bubbles: true,
    }),
  );

  input.focus();
});

const input = document.querySelector(".as-search-popup__input");
const clearBtn = document.querySelector(".as-search-popup__clear");

input?.addEventListener("input", () => {
  clearBtn.hidden = !input.value.length;
});

clearBtn?.addEventListener("click", () => {
  input.value = "";

  input.dispatchEvent(
    new Event("input", {
      bubbles: true,
    }),
  );

  input.focus();
});

function initHeaderCustomScrollbars() {
  const wrappers = document.querySelectorAll(".as-header__submenu-products");

  wrappers.forEach((wrapper) => {
    const scrollEl = wrapper.querySelector("[data-custom-scroll]");
    const thumb = wrapper.querySelector(".as-custom-scrollbar__thumb");

    if (!scrollEl || !thumb) return;

    const update = () => {
      const scrollHeight = scrollEl.scrollHeight;
      const clientHeight = scrollEl.clientHeight;
      const scrollTop = scrollEl.scrollTop;

      if (scrollHeight <= clientHeight) {
        wrapper.classList.remove("has-scroll");
        thumb.style.height = "0px";
        thumb.style.transform = "translateY(0)";
        return;
      }

      wrapper.classList.add("has-scroll");

      const trackHeight = clientHeight;
      const thumbHeight = Math.max(
        (clientHeight / scrollHeight) * trackHeight,
        30,
      );
      const maxThumbMove = trackHeight - thumbHeight;
      const maxScroll = scrollHeight - clientHeight;
      const thumbTop = (scrollTop / maxScroll) * maxThumbMove;

      thumb.style.height = `${thumbHeight}px`;
      thumb.style.transform = `translateY(${thumbTop}px)`;
    };

    scrollEl.addEventListener("scroll", update);
    window.addEventListener("resize", update);

    update();
  });
}

document.addEventListener("DOMContentLoaded", initHeaderCustomScrollbars);
